// @ts-check
// ====== F1: Kanban delle azioni aperte ======
// 3 colonne (Da richiedere → Richieste → Sì) con drag&drop.
// Trascinando una card si lancia api.updateAccessStato + log audit.
// Esposto come modalità alternativa nella vista "Azioni" (toggle Lista|Kanban).

const KANBAN_COLS = [
  {
    stato: 'Da richiedere',
    label: 'Da richiedere',
    next: ['Richieste', 'Sì', 'Da eliminare'],
    hint: 'Utenze da chiedere al cliente'
  },
  {
    stato: 'Richieste',
    label: 'Richieste',
    next: ['Sì', 'Da richiedere'],
    hint: 'In attesa di evasione'
  },
  {
    stato: 'Sì',
    label: 'Sì (attive)',
    next: ['Da eliminare'],
    hint: 'Utenze operative'
  }
];

let _kanbanMode = 'list'; // 'list' | 'kanban'

/** Renderizza Kanban dentro un container generico. */
function renderKanban(container) {
  // @ts-ignore — collectActions globale
  const all = collectActions();
  // Filtri della vista Azioni (state in azioni.js)
  // @ts-ignore — _azioniState globale
  const f = globalThis._azioniState || {};
  let actions = all;
  if (f.filterCPL) actions = actions.filter((a) => a.cpl === f.filterCPL);
  if (f.filterPM1) actions = actions.filter((a) => a.pm1 === f.filterPM1);
  if (f.filterPM2) actions = actions.filter((a) => a.pm2 === f.filterPM2);
  if (f.filterRisorsa) actions = actions.filter((a) => a.risorsa === f.filterRisorsa);

  const byStato = new Map(KANBAN_COLS.map((c) => [c.stato, []]));
  actions.forEach((a) => {
    if (byStato.has(a.stato)) byStato.get(a.stato).push(a);
  });

  container.innerHTML = `<div class="kanban">${KANBAN_COLS.map((col) => {
    const items = byStato.get(col.stato);
    return `
      <div class="kanban-col" data-stato="${col.stato}">
        <div class="kanban-col-head">
          <span>${escapeHtml(col.label)}</span>
          <span class="count-pill">${items.length}</span>
        </div>
        <div class="kanban-list" data-drop-stato="${col.stato}">
          ${
            items.length
              ? items.map((a) => kanbanCardHtml(a)).join('')
              : `<div class="kanban-empty">Nessuna voce</div>`
          }
        </div>
      </div>`;
  }).join('')}</div>`;

  wireKanbanDnD(container);
}

function kanbanCardHtml(a) {
  return `<article class="kanban-card"
      draggable="true"
      data-cliente="${escapeHtml(a.cliente)}"
      data-risorsa="${escapeHtml(a.risorsa)}"
      data-stato="${escapeHtml(a.stato)}">
    <div class="kc-cliente">${escapeHtml(a.cliente)}</div>
    <div class="kc-row">
      <span class="status ${statusClass(a.stato)}">${escapeHtml(a.risorsa)}</span>
    </div>
    <div class="kc-meta">${escapeHtml(a.cpl || 'senza CPL')}${a.pm1 ? ' · PM1 ' + escapeHtml(a.pm1) : ''}</div>
  </article>`;
}

function wireKanbanDnD(container) {
  let _dragSrc = null;

  container.querySelectorAll('.kanban-card').forEach((card) => {
    card.addEventListener('dragstart', (e) => {
      _dragSrc = card;
      card.classList.add('dragging');
      try {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', card.dataset.cliente + '|' + card.dataset.risorsa);
      } catch (_) {
        /* ignore */
      }
    });
    card.addEventListener('dragend', () => {
      card.classList.remove('dragging');
      _dragSrc = null;
      container.querySelectorAll('.kanban-list').forEach((l) => l.classList.remove('dragover'));
    });
    // Click sulla card → apre cliente
    card.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      // @ts-ignore — openModal globale
      if (typeof openModal === 'function') openModal(card.dataset.cliente, 'accessi');
    });
  });

  container.querySelectorAll('.kanban-list').forEach((list) => {
    list.addEventListener('dragover', (e) => {
      e.preventDefault();
      try {
        e.dataTransfer.dropEffect = 'move';
      } catch (_) {
        /* ignore */
      }
      list.classList.add('dragover');
    });
    list.addEventListener('dragleave', () => list.classList.remove('dragover'));
    list.addEventListener('drop', async (e) => {
      e.preventDefault();
      list.classList.remove('dragover');
      if (!_dragSrc) return;
      const targetStato = list.dataset.dropStato;
      const cliente = _dragSrc.dataset.cliente;
      const risorsa = _dragSrc.dataset.risorsa;
      const fromStato = _dragSrc.dataset.stato;
      if (!targetStato || targetStato === fromStato) return;
      try {
        // @ts-ignore — api globale
        await api.updateAccessStato(cliente, risorsa, targetStato);
        // @ts-ignore
        logAudit({
          action: 'update',
          entity: 'Cliente',
          target: cliente,
          changes: [{ field: `Accesso · ${risorsa}`, from: fromStato, to: targetStato }]
        });
        // @ts-ignore — refreshClient globale
        if (typeof refreshClient === 'function') await refreshClient(cliente);
        // @ts-ignore — bus globale
        globalThis.bus?.emit('accessi:changed', { cliente, risorsa, stato: targetStato });
        // @ts-ignore
        toast(`${cliente} · ${risorsa} → ${targetStato}`);
        renderKanban(container);
        // @ts-ignore
        if (typeof renderDashboard === 'function') renderDashboard();
      } catch (err) {
        console.error('Kanban drop error', err);
        // @ts-ignore
        toast('Errore aggiornamento: ' + (err.message || err));
      }
    });
  });
}

/** Toggle Lista|Kanban dentro la vista Azioni. */
function setAzioniMode(mode) {
  _kanbanMode = mode === 'kanban' ? 'kanban' : 'list';
  const listContainer = document.getElementById('azioniContainer');
  const kanbanContainer = ensureKanbanContainer();
  document.getElementById('azModeList')?.classList.toggle('active', _kanbanMode === 'list');
  document.getElementById('azModeKanban')?.classList.toggle('active', _kanbanMode === 'kanban');
  document
    .getElementById('azModeList')
    ?.setAttribute('aria-pressed', String(_kanbanMode === 'list'));
  document
    .getElementById('azModeKanban')
    ?.setAttribute('aria-pressed', String(_kanbanMode === 'kanban'));
  if (listContainer) listContainer.classList.toggle('hidden', _kanbanMode !== 'list');
  if (kanbanContainer) kanbanContainer.classList.toggle('hidden', _kanbanMode !== 'kanban');
  if (_kanbanMode === 'kanban') renderKanban(kanbanContainer);
}

function ensureKanbanContainer() {
  let el = document.getElementById('azioniKanban');
  if (el) return el;
  const view = document.getElementById('view-azioni');
  if (!view) return null;
  el = document.createElement('div');
  el.id = 'azioniKanban';
  el.className = 'hidden';
  view.appendChild(el);
  return el;
}

function ensureToggleControls() {
  const filters = document.querySelector('#view-azioni .filters');
  if (!filters || document.getElementById('azModeKanban')) return;
  const grp = document.createElement('div');
  grp.className = 'segmented';
  grp.setAttribute('role', 'tablist');
  grp.setAttribute('aria-label', 'Modalità visualizzazione azioni');
  grp.innerHTML = `
    <button type="button" id="azModeList" class="active" aria-pressed="true">Lista</button>
    <button type="button" id="azModeKanban" aria-pressed="false">Kanban</button>`;
  // Inserisci PRIMA del wrapper "Espandi/Comprimi" se presente, altrimenti in fondo
  const lastDiv = filters.querySelector('div[style*="margin-left"]');
  if (lastDiv) filters.insertBefore(grp, lastDiv);
  else filters.appendChild(grp);
  grp.querySelector('#azModeList').addEventListener('click', () => setAzioniMode('list'));
  grp.querySelector('#azModeKanban').addEventListener('click', () => setAzioniMode('kanban'));
}

// Hook: ogni volta che renderAzioni viene chiamato, renderKanban si rifresha se attivo
const _origRenderAzioni = globalThis.renderAzioni;
if (typeof _origRenderAzioni === 'function') {
  globalThis.renderAzioni = function () {
    ensureToggleControls();
    _origRenderAzioni.apply(this, arguments);
    if (_kanbanMode === 'kanban') {
      const c = ensureKanbanContainer();
      if (c) renderKanban(c);
    }
  };
}

// Inizializzazione: assicura i controlli appena la vista esiste
document.addEventListener('DOMContentLoaded', () => {
  ensureToggleControls();
});

// @ts-ignore
Object.assign(globalThis, { renderKanban, setAzioniMode });
export {};
